import { getInterestRate, calculateDownPayment } from '@atc/wallet-payment-fns';
async function calculateMonthlyBudget(_ref) {
  let {
    payload,
    paymentsInfo,
    paymentCalculationFetcher
  } = _ref;
  const paymentsState = {
    ...paymentsInfo,
    ...payload
  };
  const {
    loanTerm,
    budget = 0,
    tradeIn,
    interestRate,
    creditType
  } = paymentsState;
  const tradeInParam = tradeIn?.value || 0;
  const amountOwedParam = tradeIn?.amountOwed || 0;
  const interestRateParam = getInterestRate(interestRate);
  const downPaymentParam = calculateDownPayment(budget, paymentsState);
  const paymentParams = `budget=${budget}&terms=${loanTerm}&customRate=${interestRateParam}&downPayment=${downPaymentParam}&tradeInValue=${tradeInParam}&amountOwed=${amountOwedParam}&creditRange=${creditType}`;
  const {
    rates = {}
  } = (await paymentCalculationFetcher.fetch(paymentParams)) || {};

  // monthly payment from response
  return rates?.[creditType]?.custom?.[loanTerm]?.[0]?.payment;
}
export { calculateMonthlyBudget as default };
